.root {
  border-radius: 9999px;
}

.subtle {
  --mtdsc-tag-background: var(--mtds-color-background-tinted);
  --mtdsc-tag-border-color: transparent;
}

.filled {
  --mtdsc-tag-border-color: transparent;
}

.outlined {
  --mtdsc-tag-background: transparent;
  --mtdsc-tag-border-color: var(--mtds-color-border-subtle);
}

.default {
  --mtdsc-tag-color: var(--mtds-color-text-default);
}

.main {
  --mtdsc-tag-color: var(--mtds-color-main-text-default);
}
